export const checkATS = (data, template, layout) => {
  const checks = [];
  let score = 100;

  // 1. Contact info
  if (!data.personalInfo.fullName) { checks.push({ pass: false, msg: 'Add your full name', severity: 'high' }); score -= 10; }
  else checks.push({ pass: true, msg: 'Full name provided' });

  if (!data.personalInfo.email) { checks.push({ pass: false, msg: 'Add email address', severity: 'high' }); score -= 8; }
  else checks.push({ pass: true, msg: 'Email address provided' });

  if (!data.personalInfo.phone) { checks.push({ pass: false, msg: 'Add phone number', severity: 'high' }); score -= 8; }
  else checks.push({ pass: true, msg: 'Phone number provided' });

  // 2. Summary
  if (!data.summary || data.summary.length < 20) { checks.push({ pass: false, msg: 'Professional summary is too short or missing', severity: 'medium' }); score -= 8; }
  else if (data.summary.length < 100) { checks.push({ pass: true, msg: 'Summary present but could be more detailed', severity: 'low' }); score -= 3; }
  else checks.push({ pass: true, msg: 'Good professional summary' });

  // 3. Skills
  if (data.skills.length === 0) { checks.push({ pass: false, msg: 'No skills listed', severity: 'high' }); score -= 12; }
  else if (data.skills.length < 5) { checks.push({ pass: false, msg: 'Add more skills (aim for 8-15)', severity: 'medium' }); score -= 5; }
  else checks.push({ pass: true, msg: `${data.skills.length} skills listed` });

  // 4. Work experience
  if (data.professionalExperience.length === 0) { checks.push({ pass: false, msg: 'No work experience listed', severity: 'high' }); score -= 12; }
  else {
    const hasDescriptions = data.professionalExperience.every(e => e.description && e.description.length > 20);
    if (!hasDescriptions) { checks.push({ pass: false, msg: 'Some experience entries lack descriptions', severity: 'medium' }); score -= 5; }
    else checks.push({ pass: true, msg: 'Experience entries have descriptions' });
  }

  // 5. Education
  if (data.education.length === 0 || !data.education[0].school) { checks.push({ pass: false, msg: 'No education listed', severity: 'medium' }); score -= 8; }
  else checks.push({ pass: true, msg: 'Education listed' });

  // 6. Layout & Template
  if (layout === 'two-column') { checks.push({ pass: false, msg: 'Two-column layouts may confuse some ATS parsers', severity: 'medium' }); score -= 5; }
  else checks.push({ pass: true, msg: 'Single-column layout is ATS-friendly' });

  // 7. Quantifiable achievements
  const allText = JSON.stringify(data).toLowerCase();
  const numberRegex = /\d+/g;
  const numbers = allText.match(numberRegex);
  if (!numbers || numbers.length < 3) { checks.push({ pass: false, msg: 'Add quantifiable achievements (numbers, percentages)', severity: 'medium' }); score -= 5; }
  else checks.push({ pass: true, msg: 'Contains quantifiable metrics' });

  // 8. Standard section headings
  checks.push({ pass: true, msg: 'Standard section headings used (ATS-compatible)' });

  // 9. File format
  checks.push({ pass: true, msg: 'PDF export available (best for ATS submission)' });

  // 10. Action verbs
  const actionVerbs = ['developed', 'implemented', 'created', 'managed', 'led', 'designed', 'built', 'achieved', 'improved', 'reduced', 'increased', 'delivered', 'established', 'generated'];
  const foundVerbs = actionVerbs.filter(v => allText.includes(v));
  if (foundVerbs.length < 2) { checks.push({ pass: false, msg: 'Use more action verbs (developed, implemented, led, etc.)', severity: 'low' }); score -= 4; }
  else checks.push({ pass: true, msg: `${foundVerbs.length} action verbs detected` });

  score = Math.max(0, Math.min(100, score));

  return { score, checks };
};
